// ==============================|| COLOR PALETTE BUILDER ||============================== //

export function buildPaletteColors() {
  return {
    red: [
      '#fff1f1', '#ffccc7', '#ffa39e', '#ff7875', '#ff4d4f', 
      '#f5222d', '#cf1322', '#b82d2a', '#820014', '#5c0011',
      '#ff7874'
    ],
    blue: [
      '#f4f7ff', '#cddbf7', '#DBE6FF', '#9fbbf5', '#87abf5', 
      '#5c8ff7', '#0875eaff', '#4968A9', '#1E3565', '#0F2043',
      '#6586CB'
    ],
    green: [
      '#f2fff3', '#d9f7be', '#b7eb8f', '#95de64', '#73d13d', 
      '#52c41a', '#389e0d', '#26882A', '#146618', '#092b00'
    ],
    cyan: [
      '#e6fffb', '#b5f5ec', '#87e8de', '#5cdbd3', '#36cfc9', 
      '#13c2c2', '#08979c', '#006d75', '#00474f', '#002329'
    ],
    gold: [
      '#fff8f1', '#fff1b8', '#ffe58f', '#ffd666', '#ffc53d', 
      '#faad14', '#d48806', '#b8732a', '#8F5210', '#613400'
    ]
  };
}

export const GREY_PALETTE = [
  '#ffffff', 
  '#F2F2F2', 
  '#f5f5f5', 
  '#F4F7FF', 
  '#DEDEDE', 
  '#bfbfbf', 
  '#c9c9c9', 
  '#47494F', 
  '#9B9CA0', 
  '#141414', 
  '#000000',
  '#fafafa', 
  '#707278', 
  '#434343', 
  '#1f1f1f', // Ascent
  '#fafafb', 
  '#e6ebf1',
  '#85878c',// Constant
  '#B1B2B5',
];